import { Settings2 } from 'lucide-react'
import type { OutreachGroup } from '@/api/client'
import { fmtCount, pct, repliedOf, sentOf, sumCounts } from '@/lib/creators'
import { Button, DataTable, type Column } from '@/ui'

/** 결과 — one row per group, so the groups can be compared. Reply and accept
 *  rates are of the messages sent; clicks are on the group's tracked links. */
export function ResultsTable({ groups, onSettings }: { groups: OutreachGroup[]; onSettings: (g: OutreachGroup) => void }) {
  const columns: Column<OutreachGroup>[] = [
    { key: 'g', header: '그룹', card: 'title', cell: (g) => <span className="font-medium">{g.label}</span> },
    {
      key: 'offer',
      header: '제안',
      cell: (g) => <span className="block truncate">{g.offer || '—'}</span>,
      className: 'max-w-[14rem]',
    },
    { key: 'sent', header: '보냄', align: 'right', cell: (g) => <span className="tabular-nums">{fmtCount(sentOf(g.counts))}</span> },
    {
      key: 'reply',
      header: '답장률',
      align: 'right',
      cell: (g) => <span className="tabular-nums">{pct(repliedOf(g.counts), sentOf(g.counts))}</span>,
    },
    {
      key: 'accept',
      header: '수락률',
      align: 'right',
      cell: (g) => <span className="tabular-nums">{pct(g.counts.accepted, sentOf(g.counts))}</span>,
    },
    { key: 'clicks', header: '클릭', align: 'right', cell: (g) => <span className="tabular-nums">{fmtCount(g.clicks)}</span> },
    {
      key: 'act',
      header: '',
      card: 'actions',
      align: 'right',
      cell: (g) => (
        <Button size="sm" variant="ghost" icon={Settings2} onClick={() => onSettings(g)}>
          설정
        </Button>
      ),
    },
  ]
  const total = sumCounts(groups.map((g) => g.counts))
  return (
    <div className="space-y-3">
      <DataTable label="그룹별 결과" columns={columns} rows={groups} rowKey={(g) => g.id} />
      {groups.length > 1 && (
        <p className="text-meta text-muted-foreground tabular-nums">
          전체: 보냄 {fmtCount(sentOf(total))} · 답장률 {pct(repliedOf(total), sentOf(total))} · 수락률 {pct(total.accepted, sentOf(total))} · 클릭{' '}
          {fmtCount(groups.reduce((n, g) => n + g.clicks, 0))}
        </p>
      )}
      <p className="text-meta text-muted-foreground">
        답장률은 보낸 수 중 답장·수락·거절을 받은 비율이다. 보낸 수가 적을 때의 차이는 우연일 수 있다.
      </p>
    </div>
  )
}
